// src/context/AlertContext.jsx
import React, { useState, useCallback, useMemo } from 'react';
import { createBaseContext } from '../hooks/useBaseContext';

const { Context: AlertContext, useContext: useAlert } = createBaseContext('Alert');

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const push = useCallback((message, type = 'info', timeout = 3000) => {
    const id = Math.random().toString(36).slice(2);
    setAlerts((t) => [...t, { id, message, type }]);
    if (timeout) setTimeout(() => dismiss(id), timeout);
  }, []);

  const dismiss = useCallback((id) => {
    setAlerts((t) => t.filter((x) => x.id !== id));
  }, []);

  const value = useMemo(() => ({ push, dismiss }), [push, dismiss]);

  return (
    <AlertContext.Provider value={value}>
      {children}
      <div className="fixed bottom-4 right-4 space-y-2 z-50">
        {alerts.map((t) => (
          <div
            key={t.id}
            className={`px-4 py-3 rounded shadow text-white ${
              t.type === 'success' ? 'bg-green-600' :
              t.type === 'error'   ? 'bg-red-600'   :
              t.type === 'warning' ? 'bg-yellow-600': 'bg-blue-600'
            }`}
          >
            <div className="flex items-start justify-between space-x-4">
              <span>{t.message}</span>
              <button onClick={() => dismiss(t.id)} className="opacity-80 hover:opacity-100">×</button>
            </div>
          </div>
        ))}
      </div>
    </AlertContext.Provider>
  );
};
export { useAlert };